import axios from '@/libs/api.request'

export const GetAgentNotice = params => {
  return axios.request({
    url: '/print/notice',
    params,
    method: 'get'
  })
}
export const SaveAgentNotice = data => {
  return axios.request({
    url: '/print/notice',
    data,
    method: 'post'
  })
}
export const DelNotice = data => {
  return axios.request({
    url: '/print/notice/del',
    data,
    method: 'post'
  })
}
export const GetUpdateNotice = params => {
  return axios.request({
    url: '/print/cms/software',
    params,
    method: 'get'
  })
}

export const EditUpdateNotice = data => {
  return axios.request({
    url: '/print/cms/software',
    data,
    method: 'post'
  })
}

export const GetNoticeList = params => {
  return axios.request({
    url: '/print/cms/agent/notice/list',
    params,
    method: 'get'
  })
}
export const GetNoticeDetail = params => {
  return axios.request({
    url: '/print/cms/agent/notice/detail',
    params,
    method: 'get'
  })
}
export const DeleteNotice = data => {
  return axios.request({
    url: '/print/cms/agent/notice/delete',
    data,
    method: 'post'
  })
}
export const EditNotice = data => {
  return axios.request({
    url: '/print/cms/agent/notice',
    data,
    method: 'post'
  })
}
export const GetNoticeCount = params => {
  return axios.request({
    url: '/print/cms/agent/notice/count',
    params,
    method: 'get'
  })
}
export const MsgPush = data => {
  return axios.request({
    url: '/print/cms/agent/SendWechatTemplateMessage',
    data,
    method: 'post'
  })
}
